import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632baf0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "information tw-font-[13px] tw-flex tw-mr-12 tw-items-center tw-gap-2" }
const _hoisted_4 = {
  style: {"color":"#231f20","font-size":"13px","font-style":"normal","font-weight":"500","line-height":"normal"},
  class: "name-value"
}
const _hoisted_5 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_6 = { class: "tw-w-full tw-items-center tw-justify-center tw-inline-flex tw-gap-2" }
const _hoisted_7 = { class: "tw-relative" }
const _hoisted_8 = { class: "tw-absolute" }
const _hoisted_9 = { class: "tw-p-[15px]" }
const _hoisted_10 = { class: "tw-text-[14px] tw-font-[500] tw-text-[#211F58]" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[20px]"
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"var(--UI-dark-grey, #878787)","text-align":"center","font-family":"Poppins","font-size":"13px","font-style":"normal","font-weight":"400","line-height":"normal"},
  class: "tw-w-full tw-items-center tw-justify-center tw-inline-flex"
}
const _hoisted_14 = {
  style: {"letter-spacing":"1.2px","text-transform":"uppercase","font-family":"Poppins"},
  class: "tw-text-[12px] tw-text-[#211F58] tw-font-semibold tw-px-[13px] tw-pt-[17px] tw-pb-[25px]"
}
const _hoisted_15 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[73px]"
}

import { computed, Ref, ref, watch } from "vue";
import CustomTable from "@/components/common/customTable.vue";
import popoverAssessment from "@/components/assessment/popoverAssessment.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import StatusBadge from "../common/setting/statusBadge.vue";
import store from "@/store";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import ManageTemplateCatergoryItem from "./manageTemplateCatergoryItem.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Subscription } from "@/services/apiRoutes/routes";
import { getSessionPortal } from "@/services/subscriptions";
import CustomDropDownItem from "../common/customDropDownItem.vue";

export type dataActionTableColumn = {
  id: any;
  title: string;
  scoreIncreaseTotal: number;
  scoreIncreaseFirstCount: number;
  riskReduction: "High" | "Significant";
};

export default /*#__PURE__*/_defineComponent({
  __name: 'manageTemplateTable',
  props: {
  dataRow: {
    type: Array as () => dataActionTableColumn[],
    required: true,
    default: () => [],
  },
  tableData: {
    type: Array as () => any[],
    default: () => [],
  },
  tableFields: {
    type: Array as () => any[],
    default: () => [],
  },
  emptyText: {
    type: String,
    default: "",
  },
},
  emits: [
  "update-selected-rows",
  "select:row",
  "delete:assessment",
  "create:assessment",
],
  setup(__props, { emit }) {

const props = __props;



const handleDeleteAssessment = (item: any) => {
  emit("delete:assessment", item);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleCreateAssessment = (item: any) => {
  emit("create:assessment", item);
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const handleSelectTemplate = (selectedIds: number[]) => {
  const data = selectedIds.map((id) =>
    props.tableData.find((item) => item.id === id),
  );
  emit("select:row", data);
};

const items = [
  {
    text: "app-assess-assessment-modal-start-assessment-1",
    arrowRed: false,
    action: handleCreateAssessment,
  },
  {
    text: "app-assess-assessment-modal-delete-template-title-1",
    arrowRed: true,
    action: handleDeleteAssessment,
  },
];
const dataTable = ref(props.dataRow);
const isReordering: any = ref(false);
const idItemExpland = ref(null);
const isLoadingTemplateDetail = ref(false);
const descriptionTemplate: any = ref(
  getComponentUiText(
    "app-assess-assessment-manage-template-modal-description-tooltip-plan-1",
    false,
    {
      linkText: getComponentUiText(
        "app-assess-assessment-manage-template-modal-btn-click-here-1",
      ),
    },
    true,
  ),
);

const routerSubscription = async (event) => {
  if (event.target.id === "upgrade-link") {
    event.preventDefault();
    try {
      {
        const clientSecretResponse = await getSessionPortal("dashboard");
        const sessionPortalUrl =
          clientSecretResponse.data?.data?.redirectUrl || "";
        window.open(sessionPortalUrl, "_blank");
        if (!sessionPortalUrl) {
          showErrorAPI("app-settings-subscription-error-text-1", "error");
          return;
        }
        return;
      }
    } catch (error) {
      // showErrorAPI(error, Subscription.getSessionPortal);
    }
  }
};



const listTemplateDetail = computed(
  () => store.getters["Assessment/getListTemplateDetail"],
);

const reorderList = async (data) => {
  isReordering.value = true;

  store.commit("Assessment/REORDER_LIST_TEMPLETE", data);

  setTimeout(async () => {
    isReordering.value = false;
  }, 500);
};

const getTemplateDetail = async (id: number) => {
  // store.commit("Assessment/UPDATE_TOTAL_COUNT_TEMPLATE", {});
  isLoadingTemplateDetail.value = true;

  await store.dispatch("Assessment/getTemplateDetail", id);

  isLoadingTemplateDetail.value = false;
};

watch(
  () => props.dataRow,
  () => {
    dataTable.value = props.dataRow;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTable, {
    columns: __props.tableFields,
    draggable: true,
    "is-loading": isReordering.value,
    data: __props.tableData,
    "height-tb": true,
    "empty-text": __props.emptyText,
    reorderable: true,
    "header-wrapper-class": 'tw-bg-[#fcfcfd]',
    "id-item-expland": idItemExpland.value,
    onMoved: reorderList,
    onUpdateSelectedRows: _cache[0] || (_cache[0] = ($event: any) => (handleSelectTemplate($event)))
  }, {
    "cell(name)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_1, [
        (data.value?.imgSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: data.value?.imgSrc,
              alt: "person_random"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(data.value), 1)
        ])
      ])
    ]),
    "cell(templateDescription)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_5, _toDisplayString(data.value), 1)
    ]),
    "cell(templateType)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(StatusBadge, {
            label: data.value,
            "is-check-plan": 
              data.item.templatePlanEntitled || data.item.templateOrgId !== null
            ,
            "is-template-org": data.item.templateOrgId !== null,
            "class-current-user": 'tw-text-[#387dff] tw-leading-[130%] tw-bg-white tw-border tw-border-solid tw-border-[#e4f1ff] tw-rounded-[5px] tw-text-[13px] tw-font-[500]',
            value: data.value
          }, null, 8, ["label", "is-check-plan", "is-template-org", "value"]),
          _createElementVNode("span", _hoisted_8, [
            (!data.item.templatePlanEntitled)
              ? (_openBlock(), _createBlock(ButtonShowDuplicateAssessment, {
                  key: 0,
                  "id-popover": 'popover' + Math.random() * 1000,
                  "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px] ',
                  classes: `!tw-leading-none tw-ml-2`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                      "app-assess-assessment-manage-template-modal-title-tooltip-plan-1",
                    )), 1),
                      _createElementVNode("div", {
                        class: "tw-py-[10px] tw-text-[13px] tw-font-[400] tw-text-[#878787]",
                        onClick: routerSubscription,
                        innerHTML: descriptionTemplate.value
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  _: 1
                }, 8, ["id-popover"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    "cell(itemCount)": _withCtx((data) => [
      (isLoadingTemplateDetail.value && data.item.id === idItemExpland.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(data.item.itemCount), 1))
    ]),
    "cell(action)": _withCtx((data) => [
      (data.item.templatePlanEntitled)
        ? (_openBlock(), _createBlock(popoverAssessment, {
            key: 0,
            "style-button": "!tw-py-[10px] !tw-px-[10px] tw-ml-[-10px] tw-mr-[-10px] tw-items-center tw-justify-center",
            offset: 20,
            "id-popover": 'popover-manage-template-table-' + data.item.id
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(getComponentUiText)("app-menu-submenu-settings-1")), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                return _createVNode(CustomDropDownItem, {
                  key: `option_template_${index}`,
                  "id-text": `${item.text}`,
                  "custom-text-class": `tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
            item.arrowRed ? 'tw-text-[#F7553C]' : ''
          } tw-whitespace-normal`,
                  "arrow-icon-style": `${
            item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
          } tw-min-w-[7px]`,
                  padding: 'tw-px-[13px] tw-py-[12px]',
                  "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                  onClick: () => item.action(data.item)
                }, null, 8, ["id-text", "custom-text-class", "arrow-icon-style", "onClick"])
              }), 64))
            ]),
            _: 2
          }, 1032, ["id-popover"]))
        : _createCommentVNode("", true)
    ]),
    "cell(expland)": _withCtx((data) => [
      _createVNode(ArrowDownTableIcon, {
        class: _normalizeClass([
          data.item.id === idItemExpland.value ? 'show' : '',
          'tw-cursor-pointer',
        ]),
        onClick: ($event: any) => (
          (idItemExpland.value =
            idItemExpland.value === data.item.id ? null : data.item.id),
            idItemExpland.value === data.item.id
              ? getTemplateDetail(data.item.templateId)
              : null
        )
      }, null, 8, ["class", "onClick"])
    ]),
    detail: _withCtx(() => [
      (isLoadingTemplateDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(listTemplateDetail.value.categoryDetails, (item, index) => {
            return (_openBlock(), _createBlock(ManageTemplateCatergoryItem, {
              key: index,
              data: item,
              index: index
            }, null, 8, ["data", "index"]))
          }), 128))
    ]),
    _: 1
  }, 8, ["columns", "is-loading", "data", "empty-text", "id-item-expland"]))
}
}

})